export const countryConfigMA = {
  home: {
    skeleton: {
      banner: true,
      bubbles: true,
      featuredProducts: true,
      services: true,
      starredProductLists: 0,
      starredCards1: false,
      starredCards2: false,
      posts: false
    }
  },
  'landing-courier': {
    bikeCollection: 'pour-velos-et-trottinettes',
    carCollection: 'pour-les-conducteurs'
  }
};
